<template>
    <div v-loading="loading">
        <div class="row">
            <div class="col-sm-6">
                <h2>Current ({{ left.name }})</h2>
                <billing-inner :billing_period_id="left.id"
                               :no_save_btn="true"
                               ref="left"
                               @refresh-data="(data) => refreshData('left', data)"
                ></billing-inner>
            </div>
            <div class="col-sm-6">
                <h2>Next ({{ right.name }})</h2>
                <billing-inner :billing_period_id="right.id"
                               :no_save_btn="true"
                               ref="right"
                               @refresh-data="(data) => refreshData('right', data)"
                ></billing-inner>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12" style="text-align: center; margin-top: 10px;">
                <btn icon="fas fa-cloud-upload-alt" cssClass="btn-lg btn-primary" :click="save">Save</btn>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6" style="margin-top: 20px;">
                <billing-emails-modal ref="leftEmailsModal" :billing_period_id="left.id"></billing-emails-modal>
                <billing-emails-note ref="leftEmailsNote" :billing_period_id="left.id" @refresh-notes="refreshNotes('left')"></billing-emails-note>
                <billing-addons :billing_period_id="left.id" :status="leftData.status"></billing-addons>
                <billing-notes ref="leftBillingNotes" :billing_period_id="left.id"></billing-notes>
            </div>
            <div class="col-sm-6" style="margin-top: 20px;">
                <billing-emails-modal ref="rightEmailsModal" :billing_period_id="right.id"></billing-emails-modal>
                <billing-emails-note ref="rightEmailsNote" :billing_period_id="right.id" @refresh-notes="refreshNotes('right')"></billing-emails-note>
                <billing-addons :billing_period_id="right.id" :status="rightData.status"></billing-addons>
                <billing-notes ref="rightBillingNotes" :billing_period_id="right.id"></billing-notes>
            </div>
        </div>
    </div>
</template>

<script>
import BillingInner from '../dialogs/billing-inner';
import BillingNotes from '../../../BudgetNotes/vue/billing-notes';
import BillingAddons from '../../../BudgetAddOns/vue/billing-addons';
import BillingEmailsModal from "../../../BudgetEmails/vue/billing-emails-modal";
import BillingEmailsNote from "../../../BudgetEmails/vue/billing-emails-note";

export default {
    components: { BillingInner, BillingNotes, BillingAddons, BillingEmailsModal, BillingEmailsNote },
    props: [
        'left', 'right',
    ],
    data() {
        return {
            loading: false,
            leftData: this.left,
            rightData: this.right,
        };
    },
    methods: {
        save() {
            this.loading = true;

            return this.$refs['left'].save()
            .then(() => this.$refs['right'].save())
            .then(() => this.loading = false)
            .then(() => this.$refs.leftEmailsModal.dirty = false)
            .then(() => this.$refs.leftEmailsNote.dirty = false)
            .then(() => this.$refs.rightEmailsModal.dirty = false)
            .then(() => this.$refs.rightEmailsNote.dirty = false);
        },
        refreshData(side, newData) {
            if (side === 'left') {
                if (newData.billing.billable != this.left.billing.billable
                    || newData.agency.discount != this.left.agency.discount) 
                {
                    this.$refs.leftEmailsModal.dirty = this.$refs.leftEmailsNote.dirty = true;
                }
                if (newData.agency.io_number != this.left.agency.io_number) {
                    this.$refs.leftEmailsNote.dirty = true;
                }
                this.leftData = newData;
            } else {
                if (newData.billing.billable != this.right.billing.billable
                    || newData.agency.discount != this.right.agency.discount) 
                {
                    this.$refs.rightEmailsModal.dirty = this.$refs.rightEmailsNote.dirty = true;
                }
                if (newData.agency.io_number != this.right.agency.io_number) {
                    this.$refs.rightEmailsNote.dirty = true;
                }
                this.rightData = newData;
            }
        },
        refreshNotes(side) {
            if (side === 'left') {
                this.$refs.leftBillingNotes.refresh();
            } else {
                this.$refs.rightBillingNotes.refresh();
            }
        },
    },
};
</script>

<style>
</style>
